module.exports = __webpack_public_path__ + "static/media/BankDetailInformation.19194a28.svg";